import React from 'react';

import { Flex } from '@atlaskit/primitives';

import { DashedLine, TimelineStyled } from '../../styled/StyledModal';

import { FirstDay } from './days/FirstDay';
import { SecondDay } from './days/SecondDay';
import { ThirdDay } from './days/ThirdDay';
import { End } from './days/End';

export const Timeline = () => {
	return (
		<TimelineStyled>
			<Flex direction="column">
				<FirstDay />
				<DashedLine />
				<SecondDay />
				<DashedLine />
				<ThirdDay />
				<DashedLine />
				<End />
			</Flex>
		</TimelineStyled>
	);
};
